module.exports = __webpack_public_path__ + "img/fire.d4f80ea0.png";